import { DvGridFilter } from '@devinco/ui/grid';
type QuickFilterKey = 'Deleted' | 'Active' | 'All';

export const QuickFilterModel: Record<
  QuickFilterKey,
  { [key: string]: DvGridFilter }
> = {
  Deleted: { ShowRecord: { filterType: 'set', values: ['false'] } },
  Active: { ShowRecord: { filterType: 'set', values: ['true'] } },
  All: {},
};
